<template>
  <div class="geofence-fields-airport">
    <div class="row margin-T">
      <div class="small-3 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.trackEntryExit"
            @change="updateField('trackEntryExit')" />
          <span>TRACK ENTRY AND EXITS</span>
        </label>
      </div>
      <div class="small-3 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.showInAppBanner"
            @change="updateField('showInAppBanner')" />
          <span>SHOW BANNER IN PROVIDER APP</span>
        </label>
      </div>
      <div class="small-3 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.pushNotificationToProvUponEntry"
            @change="updateField('pushNotificationToProvUponEntry')" />
          <span>PUSH ENTRY NOTIFICATIONS</span>
        </label>
      </div>
      <div class="small-3 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.autoSetLocationToGeofenceName"
            @change="updateField('autoSetLocationToGeofenceName')" />
          <span>SET PICKUP/DROPOFF TO GEOFENCE</span>
        </label>
      </div>
    </div>

    <div class="row margin-T">
      <div class="small-6 columns padding-R">
        <div class="input-field">
          <label>Formal Name</label>
          <input type="name" placeholder="LAX Internation Airport" v-model="geofence.formalName"
            @change="updateFieldValue('formalName')" />
        </div>
      </div>
      <div class="small-6 columns padding-L">
        <div class="input-field">
          <label>Deactivate Provider Distance</label>
          <input type="number" placeholder="in Miles" v-model="geofence.deactiveDistance" />
        </div>
      </div>
      <!-- <div class="small-6 columns padding-L">
        <div class="input-field">
          <label>AIRPORT PICKUP INSTRUCTIONS</label>
          <textarea v-model="geofence.pickupInstructions.instructions"></textarea>
        </div>
      </div> -->
    </div>

    <div class="arrival-instruction-box row">
      <div class="row">
        <div class="small-12 columns">
          <div class="heading">
            <label data-v-71d9b8c5="">ARRIVAL INSTRUCTION</label>
            <div class="preview" @click="openPreview">
              <i class="far fa-eye"></i>
              <span>PREVIEW</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="small-12 columns padding-R">
          <div class="input-field">
            <label>Label</label>
            <input type="text" placeholder="LAX Pickup Instruction" v-model="geofence.airportPickupTitle"
              @change="updateFieldValue('airportPickupTitle')" />
          </div>
        </div>
      </div>

      <div class="row margin-T">
        <div class="small-6 columns padding-R">
          <div class="input-field">
            <label>Upstairs Label </label>
            <input type="text" placeholder="Upstairs" v-model="geofence.airportPickupUpstairs"
              @change="updateFieldValue('airportPickupUpstairs')" />
          </div>
        </div>
        <div class="small-6 columns padding-L">
          <div class="input-field">
            <label>Downstairs Label </label>
            <input type="text" placeholder="Downstairs" v-model="geofence.airportPickupDownstairs"
              @change="updateFieldValue('airportPickupDownstairs')" />
          </div>
        </div>

        <div class="small-6 columns padding-R">
          <div class="input-field">
            <label>TNC Instruction </label>
            <textarea v-model="geofence.airportPickupInstructionsTNC"
              @change="updateFieldValue('airportPickupInstructionsTNC')"></textarea>
          </div>
        </div>
        <div class="small-6 columns padding-L">
          <div class="input-field">
            <label>TCP Instruction </label>
            <textarea v-model="geofence.airportPickupInstructionsTCP"
              @change="updateFieldValue('airportPickupInstructionsTCP')"></textarea>
          </div>
        </div>

        <div class="small-6 columns padding-R margin-T">
          <div class="input-field">
            <label>TNC Image </label>
            <div class="row upload-box">
              <div class="small-8 columns padding-R">
                <input type="text" class="img-url" :disabled="geofence.uploading.tnc"
                  v-model="geofence.airportPickupImageTNC"
                  @change="updateFieldValue('airportPickupImageTNC')" />
              </div>
              <div class="small-4 columns">
                <a :class="{'button success small block':true, 'disabled':geofence.uploading.tnc}"  
                  @click="$refs.imageTNC.click()">
                  <span v-if="geofence.uploading.tnc"><i class="fas fa-spinner fa-spin"></i> Uploading..</span>
                  <span v-else-if="geofence.airportPickupImageTNC">Change</span>
                  <span v-else>Upload</span>
                </a>
                <input type="file" ref="imageTNC" v-show="false"
                  @change="upload('imageTNC')" />
              </div>
            </div>
            <span v-show="!!uploadMsg.tnc" class="error-message">{{ uploadMsg.tnc }}</span>
          </div>
        </div>
        <div class="small-6 columns padding-L margin-T">
          <div class="input-field">
            <label>TCP Image </label>
            <div class="row upload-box">
              <div class="small-8 columns padding-R">
                <input type="text" class="img-url" :disabled="geofence.uploading.tcp"
                  v-model="geofence.airportPickupImageTCP"
                  @change="updateFieldValue('airportPickupImageTNC')" />
              </div>
              <div class="small-4 columns">
                <a :class="{'button success small block':true, 'disabled':geofence.uploading.tcp}" 
                  @click="$refs.imageTCP.click()">
                  <span v-if="geofence.uploading.tcp"><i class="fas fa-spinner fa-spin"></i> Uploading...</span>
                  <span v-else-if="geofence.airportPickupImageTCP">Change</span>
                  <span v-else>Upload</span>
                </a>
                <input type="file" ref="imageTCP" v-show="false"
                  @change="upload('imageTCP')" />
              </div>
            </div>
            <span v-show="!!uploadMsg.tcp" class="error-message">{{ uploadMsg.tcp }}</span>
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="row margin-T sub-geofences">
      <div class="small-12 columns">
        <div class="heading">
          <div class="add">
            <span>Add Geofence</span>
            <select v-model="selected.stagingLots" @change="addSubGeofence('stagingLots')"
              :disabled="dragOptions.stagingLots.disabled || subgeofencesLoading">
              <option v-for="geo in activeGeofenceList('stagingLots')"
                :value="geo.id">{{ geo.name }}</option>
            </select>
          </div>
          <label>STAGING LOTS</label>
          <div class="clear"></div>
        </div>
        <div class="loader" v-show="subgeofencesLoading">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </div>

        <draggable v-model="stagingLots" :class="{'list':true, 'disabled':dragOptions.stagingLots.disabled}"
          @change="sorted('stagingLots')" v-bind="dragOptions.stagingLots">
          <div v-for="data in stagingLots" :key="data.id" class="item">
            <i class="fas fa-bars"></i>
            <span>{{data.name}}</span>
            <i class="fas fa-times" @click="toggleConfirm(data.id, 'stagingLots')"
              v-show="!deleteConfirm['a' + data.id]"></i>
            <transition name="slide-left">
              <div v-show="deleteConfirm['a' + data.id]" class="confirm">
                <span>Confirm remove?</span>
                <div class="button cta error xsmall"
                  @click="toggleConfirm(data.id, 'stagingLots')">No</div>
                <div class="button cta success xsmall"
                  @click="deleteSubGeofence(data.id, 'stagingLots')">Yes</div>
              </div>
            </transition>
          </div>
        </draggable>

      </div>
    </div>

    <div class="row margin-T sub-geofences">
      <div class="small-12 columns">
        <div class="heading">
          <div class="add">
            <span>Add Geofence</span>
            <select v-model="selected.restrictedAreas" @change="addSubGeofence('restrictedAreas')"
              :disabled="dragOptions.restrictedAreas.disabled || subgeofencesLoading">
              <option v-for="geo in activeGeofenceList('restrictedAreas')"
                :value="geo.id">{{ geo.name }}</option>
            </select>
          </div>
          <label>RESTRICTED AREAS</label>
          <div class="clear"></div>
        </div>
        <div class="loader" v-show="subgeofencesLoading">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </div>

        <draggable v-model="restrictedAreas" :class="{'list':true, 'disabled':dragOptions.restrictedAreas.disabled}"
          @change="sorted('restrictedAreas')" v-bind="dragOptions.restrictedAreas">
          <div v-for="data in restrictedAreas" :key="data.id" class="item">
            <i class="fas fa-bars"></i>
            <span>{{data.name}}</span>
            <i class="fas fa-times" @click="toggleConfirm(data.id, 'restrictedAreas')"
              v-show="!deleteConfirm['a' + data.id]"></i>
            <transition name="slide-left">
              <div v-show="deleteConfirm['a' + data.id]" class="confirm">
                <span>Confirm remove?</span>
                <div class="button cta error xsmall"
                  @click="toggleConfirm(data.id, 'restrictedAreas')">No</div>
                <div class="button cta success xsmall"
                  @click="deleteSubGeofence(data.id, 'restrictedAreas')">Yes</div>
              </div>
            </transition>
          </div>
        </draggable>

      </div>
    </div>

    <div class="row margin-T sub-geofences">
      <div class="small-12 columns">
        <div class="heading">
          <div class="add">
            <span>Add Geofence</span>
            <select v-model="selected.serviceAreas" @change="addSubGeofence('serviceAreas')"
              :disabled="dragOptions.serviceAreas.disabled || subgeofencesLoading">
              <option v-for="geo in activeGeofenceList('serviceAreas')"
                :value="geo.id">{{ geo.name }}</option>
            </select>
          </div>
          <label>SERVICE AREAS</label>
          <div class="clear"></div>
        </div>
        <div class="loader" v-show="subgeofencesLoading">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </div>

        <draggable v-model="serviceAreas" :class="{'list':true, 'disabled':dragOptions.serviceAreas.disabled}"
          @change="sorted('serviceAreas')" v-bind="dragOptions.serviceAreas">
          <div v-for="data in serviceAreas" :key="data.id" class="item">
            <i class="fas fa-bars"></i>
            <span>{{data.name}}</span>
            <i class="fas fa-times" @click="toggleConfirm(data.id, 'serviceAreas')"
              v-show="!deleteConfirm['a' + data.id]"></i>
            <transition name="slide-left">
              <div v-show="deleteConfirm['a' + data.id]" class="confirm">
                <span>Confirm remove?</span>
                <div class="button cta error xsmall"
                  @click="toggleConfirm(data.id, 'serviceAreas')">No</div>
                <div class="button cta success xsmall"
                  @click="deleteSubGeofence(data.id, 'serviceAreas')">Yes</div>
              </div>
            </transition>
          </div>
        </draggable>

      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
import airportGeofenceAPI from '@/modules/api/geofences/airport'
import draggable from 'vuedraggable'

export default {
  name: 'geofence-fields-airport',
  props: [ 'geofence', 'loadOtherData' ],
  components: { draggable },
  data () {
    return {
      subgeofencesLoading: false,
      stagingLots: [],
      restrictedAreas: [],
      serviceAreas: [],
      selected: {
        stagingLots: '',
        restrictedAreas: '',
        serviceAreas: ''
      },
      dragOptions: {
        stagingLots: { disabled: false },
        restrictedAreas: { disabled: false },
        serviceAreas: { disabled: false },
      },
      deleteConfirm: {},
      searched: {
        stagingLots: false,
        restrictedAreas: false,
        serviceAreas: false
      },
      uploadMsg: {
        tnc: '',
        tcp: ''
      }
    }
  },
  computed: {
    geofences () { return this.$store.state.geofences.geofences.items },
    activeLoading () { return this.$store.state.geofences.geofences.active.loading }
  },
  methods: {
    updateField (field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      })
    },
    updateFieldValue (field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field]
      })
    },
    getActiveGeofences () {
      let self = this
      let active = self.$store.state.geofences.geofences.active

      if (self.activeLoading) { return }

      let request = {
        token: self.$store.state.session.sessionToken,
        pageSize: 100,
        status: 'active'
      }

      if (!self.searched.stagingLots) {
        request.type = 'staging'
      } else if (!self.searched.restrictedAreas) {
        request.type = 'restricted'
      } else if (!self.searched.serviceAreas) {
        request.type = 'servicearea'
      }

      self.$store.commit('geofences/setGeofenceActiveLoading', true)
      if (request.type === 'servicearea') {
        self.$sdk.get('/servicearea', {
          token: self.$store.state.session.sessionToken,
          brandId: -2
        }, r => {
          self.$store.commit('geofences/setGeofenceActiveLoading', false)
          if (r.error) { return }

          let result = []
          for (let i = 0; i < r.list.length; i++) {
            let item = r.list[i]
            item['showForm'] = false
            if (!r.list[i].airportAssoc) {
              result.push(item)
            }
          }

          let field = 'stagingLots'
          if (request.type === 'restricted') { field = 'restrictedAreas' }
          if (request.type === 'servicearea') { field = 'serviceAreas' }

          // sort alphabetically
          result.sort(function (a, b) {
            if (a.name < b.name) { return -1 }
          	if (a.name > b.name) { return 1 }
          	return 0
          })
          self.$store.commit('geofences/setGeofenceActive', {
            field: field,
            value: result
          })

          self.searched[field] = true

          self.getActiveGeofences()
        }, '2.0')
      } else if (request.type) {
        self.$sdk.get('/geofences/search', request, r => {
          self.$store.commit('geofences/setGeofenceActiveLoading', false)
          if (r.error) { return }

          let result = []
          for (let i = 0; i < r.list.length; i++) {
            let item = r.list[i]
            item['showForm'] = false
            if (!r.list[i].airportAssoc) {
              result.push(item)
            }
          }

          let field = 'stagingLots'
          if (request.type === 'restricted') { field = 'restrictedAreas' }
          if (request.type === 'servicearea') { field = 'serviceAreas' }

          // sort alphabetically
          result.sort(function (a, b) {
            if (a.name < b.name) { return -1 }
          	if (a.name > b.name) { return 1 }
          	return 0
          })
          self.$store.commit('geofences/setGeofenceActive', {
            field: field,
            value: result
          })

          self.searched[field] = true

          self.getActiveGeofences()
        })
      }
    },
    activeGeofenceList (field) {
      let activeGeofences = this.$store.state.geofences.geofences.active

      let filtered = activeGeofences[field]
      this[field].forEach(function (data) {
        filtered = filtered.filter(activeGeo => activeGeo.id !== data.id)
      })

      return filtered || []
    },
    sorted (field) {
      let self = this
      self.dragOptions[field].disabled = true
      self.$store.commit('geofences/setAirportSubgeofence', {
        id: self.geofence.id,
        field: field,
        value: self[field]
      })

      let priority = {}
      let i = 1
      self[field].forEach(function (geo) {
        priority[geo.id] = i
        i++
      })

      airportGeofenceAPI.updateSubGeofence(self, {
        id: self.geofence.id,
        priority: priority
      }, function (res) {
        self.dragOptions[field].disabled = false
      })
    },
    addSubGeofence (field) {
      let self = this
      self.dragOptions[field].disabled = true

      airportGeofenceAPI.addSubGeofence(self, {
        id: self.geofence.id,
        subID: self.selected[field],
        priority: self[field].length + 1
      }, function (res) {
        self.dragOptions[field].disabled = false
        if (!res.error) {
          let index = self.activeGeofenceList(field).findIndex(x => x.id === self.selected[field])
          let selectedGeo = self.activeGeofenceList(field)[index]
          self[field].push({
            id: selectedGeo.id,
            name: selectedGeo.name
          })
          self.$store.commit('geofences/setAirportSubgeofence', {
            id: self.geofence.id,
            field: field,
            value: self[field]
          })
        }
      })
    },
    toggleConfirm (id, field) {
      let self = this
      if (self.dragOptions[field].disabled) { return }

      if (!self.deleteConfirm['a' + id]) {
        self.deleteConfirm['a' + id] = false
      }
      self.deleteConfirm['a' + id] = !self.deleteConfirm['a' + id]

      // Rerender trick
      let backup = self.deleteConfirm
      self.deleteConfirm = {}
      self.$nextTick(() => { self.deleteConfirm = backup })
    },
    deleteSubGeofence (id, field) {
      let self = this
      if (self.dragOptions[field].disabled) { return }

      self.dragOptions[field].disabled = true
      airportGeofenceAPI.removeSubGeofence(self, {
        id: self.geofence.id,
        subID: id
      }, function (res) {
        self.dragOptions[field].disabled = false
        if (!res.error) {
          let index = self[field].findIndex(x => x.id === id)
          self[field].splice(index, 1)
          self.$store.commit('geofences/setAirportSubgeofence', {
            id: self.geofence.id,
            field: field,
            value: self[field]
          })

          self.selected[field] = ''
        }
      })

    },
    stripScripts (data) {
      let div = document.createElement('div')
      div.innerHTML = data
      let scripts = div.getElementsByTagName('script')
      var i = scripts.length
      while (i--) {
        scripts[i].parentNode.removeChild(scripts[i])
      }
      return div.innerHTML
    },
    upload (target) {
      let self = this
      let _target = target === 'imageTNC' ? 'tnc' : 'tcp'

      if (!self.$refs[target].files.length || self.geofence.uploading[_target]) {
        return
      }

      self.geofence.uploading[_target] = true
      self.$emit('uploading', {
        type: _target,
        value: true
      })

      self.uploadMsg[_target] = ''

      let file = self.$refs[target].files[0]
      let fd = new FormData()
      fd.append('pic', file)

      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        self.geofence.uploading[_target] = false
        self.$emit('uploading', {
          type: _target,
          value: false
        })

        if (!res.body.success) {
          self.uploadMsg[_target] = 'Upload fail. Please try again.'
          return
        }

        // geofence.airportPickupImageTNC
        if (_target === 'tnc') {
          self.geofence.airportPickupImageTNC = res.body.data.url
        } else {
          self.geofence.airportPickupImageTCP = res.body.data.url
        }
      }, function (res) {
        console.log('error', res)
      })
    },
    openPreview () {
      let self = this
      let url = location.href + '/preview'

      self.$store.commit('geofences/setPreview', {
        title: self.geofence.airportPickupTitle,
        tnc: {
          text: self.geofence.airportPickupInstructionsTNC,
          img: self.geofence.airportPickupImageTNC
        },
        tcp: {
          text: self.geofence.airportPickupInstructionsTCP,
          img: self.geofence.airportPickupImageTCP
        }
      })

      let popup = window.open(url, 'instructionPreview', 'location=0,width=1020,height=' + window.outerHeight)
      popup.focus()
      popup.onload = function () {
        self.$store.commit('geofences/setPreview', {
          title: self.geofence.airportPickupTitle,
          tnc: {
            text: self.geofence.airportPickupInstructionsTNC,
            img: self.geofence.airportPickupImageTNC
          },
          tcp: {
            text: self.geofence.airportPickupInstructionsTCP,
            img: self.geofence.airportPickupImageTCP
          }
        })
      }
    }
  },
  watch: {
    loadOtherData: function (value) {
      let self = this
      let index = self.geofences.findIndex(x => x.id === this.geofence.id)

      if (index > -1 && !self.geofences[index].stagingLots) {
        self.subgeofencesLoading = true
        airportGeofenceAPI.getSubgeofences(self, self.geofence.id, function (res) {
          if (!res.error) {
            // set StagingLots Data
            res.staging.forEach(function (data) {
              self.stagingLots.push({
                id: data.id,
                name: data.name
              })
            })

            // set RestrictedAreas Data
            res.restricted.forEach(function (data) {
              self.restrictedAreas.push({
                id: data.id,
                name: data.name
              })
            })

            // set RestrictedAreas Data
            res.servicearea.forEach(function (data) {
              self.serviceAreas.push({
                id: data.id,
                name: data.name
              })
            })
          }
          self.subgeofencesLoading = false
          self.getActiveGeofences()
        })
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>

.input-field {
  font-size: 14px;

  & label {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
  }

  & input, & textarea {
    margin-top: 0;
    padding: 7px 10px;
  }

  & textarea {
    resize: none;
    height: 100px;
  }
}

.checkbox-input {
  & > * {
    display: inline-block;
    vertical-align: middle;
    width: auto;
  }
  & input {
    margin-top: 0;
  }
  & span {
    font-size: 12px;
    font-weight: 700;
    color: #777;
    height: 16px;
    margin-left: 3px;
    cursor: pointer;
  }
}

.arrival-instruction-box{
  border: 1px solid #ccc;
  padding: 15px;
  background: #fafafa;
  margin-top: 15px;

  .heading{
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
    position: relative;

    label{ color: #555; }
    .preview{
      position: absolute;
      top: 0;
      right: 0;
      text-align: center;
      line-height: 1;
      padding: 5px;
      border: 1px solid #ccc;
      border-radius: 4px;
      background: #fff;
      color: #555;
      box-shadow: 2px 2px 2px rgba(0,0,0, .1);
      cursor: pointer;

      i{ margin-bottom: 1px; }
      span{
        font-size: 9px;
        display: block;
      }
    }
  }
  .error-message{
    font-size: 12px;
    color: #ec3e3e;
    line-height: 1;
    margin: 2px 0;
  }
}

.sub-geofences{
  margin-bottom: 20px;

  .heading{
    border-bottom: 2px solid #ccc;

    label{
      font-weight: 600;
      color: #0D79F2;
      padding-top: 5px;
      display: block;
    }
    .add{
      float: right;
      padding-bottom: 5px;

      span{
        display: inline-block;
        margin-right: 5px;
        font-weight: 600;
        font-size: 13px;
        color: #777;
      }
      select{
        width: 150px;
        &[disabled]{ background-color: #ebebe4; }
      }
    }
  }
  .loader{
    padding: 10px 5px;
    font-size: 14px;
    color: #555;

    i{ margin-right: 5px; }
  }
  .list{
    margin: 5px 0;
    padding: 0;

    &.disabled{ opacity: .6; }
    .item{
      padding: 5px 10px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      position: relative;

      &:nth-child(even){ background: #fafafa; }
      &.sortable-chosen{ background: #b2e6ff; }
    }
    .fa-bars{
      color: #bbb;
      margin-right: 5px;
    }
    span{
      font-size: 14px;
      color: #555;
      font-weight: 600;
    }
    .fa-times{
      float: right;
      color: #e62a2a;
      font-size:21px;
      margin: 2px 5px 0 0;
    }
  }
}

.confirm{
    position: absolute;
    right: 0;
    top: 5px;
    line-height: 24px;

    span{
      display: inline-block;
      vertical-align: middle;
    }
    .button{
      vertical-align: middle;
      padding: 4px 13px 5px;
    }
}

.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
.margin-T { margin-top: 15px; }
.clear { clear:both; }

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .padding-R, .padding-L {
    padding: 0;
  }

  .margin-T {
    margin-top: 5px;
  }

  .small-2, .small-5, .small-6, .small-3, .small-4, .small-8 {
    width: 100%;
  }

  .small-6 {
    margin-bottom: 5px;
  }

  .confirm {
    background-color: #fff;
    width: 100%;
    text-align: right;
  }

  .heading {
    display: flex;
    flex-direction: column-reverse;

    .add {
      text-align: right;
    }

    label {
      margin-bottom: 5px;
    }
  }

  .sub-geofences {
    .list {
      span {
        font-size: 12px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofenceFieldsAirport.vue